/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMinIcon16Light = forwardRef('UiFrameSizeMinIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5 2a.5.5 0 0 1 .5.5V5a1 1 0 0 0 1 1h2.5a.5.5 0 0 1 0 1H11a2 2 0 0 1-2-2V2.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M2.5 9a.5.5 0 0 0 0 1H5a1 1 0 0 1 1 1v2.5a.5.5 0 0 0 1 0V11a2 2 0 0 0-2-2H2.5Z" }),
        React.createElement("path", { d: "M11 9a2 2 0 0 0-2 2v2.5a.5.5 0 0 0 1 0V11a1 1 0 0 1 1-1h2.5a.5.5 0 0 0 0-1H11Z" }),
        React.createElement("path", { d: "M7 2.5a.5.5 0 0 0-1 0V5a1 1 0 0 1-1 1H2.5a.5.5 0 0 0 0 1H5a2 2 0 0 0 2-2V2.5Z" })));
});
